import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { CustomFieldMutator } from '@/lib/entity/custom_field'
import type { Converter } from '@/lib/converter/entityFormatter'
import { asModifiedField } from '@/lib/converter/entityFormatter'

type CustomFieldSchema = CustomFieldMutator['merged']

export const CustomFieldConverter: Converter<CustomFieldSchema> = {
  icon: () => i18next.t('stages.icon.custom_field'),
  title: () => i18next.t('stages.table.custom_field'),
  subTitle: async (merged) => merged.name ?? i18next.t('ui.common.inputting'),
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.custom_field.${column}`)
    return match(column)
      .with('name', 'key', 'description', 'value_type', 'visible', 'required', () => {
        if (column === 'value_type') {
          return asModifiedField(label, i18next.t(`customField.${modified[column]}`))
        }
        return asModifiedField(label, modified[column]!)
      })
      .with('id', 'order', () => undefined)
      .exhaustive()
  }
}
